/** Dark-theme color tokens for the rider v2 portal. */
export const RIDER_THEME = {
  bg: '#080C16', surface: '#0F1623', card: '#141E2E', cardHover: '#1A2640',
  border: '#1C2A40', borderLight: '#243450',
  accent: '#F59E0B', accentDim: '#92400E', accentGlow: '#F59E0B44',
  green: '#10B981', greenDim: '#064E3B', greenGlow: '#10B98133',
  red: '#EF4444', redDim: '#7F1D1D',
  blue: '#3B82F6', blueDim: '#1E3A8A',
  purple: '#8B5CF6', orange: '#F97316',
  text: '#F0F6FF', textMid: '#8BA3C0', textDim: '#3D5A7A',
};

/** Bilingual UI copy (ar / en) for the rider v2 portal. */
export const RIDER_TEXT = {
  ar: {
    dir: 'rtl', font: "'Cairo',Tahoma,sans-serif",
    appName: 'سريع', greeting0: 'صباح الخير', greeting1: 'مساء الخير', greeting2: 'مساء النور',
    online: 'متصل', offline: 'غير متصل',
    pending: 'بانتظار', active: 'نشطة', done: 'مكتملة', earned: 'محصل',
    nav: ['الواردة', 'النشطة', 'التحصيلات', 'السجل', 'الإعدادات'],
      incomingTitle: 'طلبات بانتظار القبول',
      incomingEmpty: 'لا توجد طلبات جديدة',
      incomingEmptySub: 'ستظهر الطلبات المُسندة إليك هنا',
      goActiveTab: 'الطلبات النشطة',
      collectFromCustomer: 'تحصيل من الزبون',
      viewOrder: 'عرض الطلب',
      cod: 'الدفع عند الاستلام', paid: 'مدفوع مسبقاً',
      accept: 'قبول الطلب', reject: 'رفض',
      headToStore: 'التوجه للمتجر', arrivedStore: 'وصلت المتجر',
      confirmPickup: 'تم الاستلام من المتجر',
      headToCustomer: 'التوجه للزبون', arrivedCustomer: 'وصلت الزبون',
      confirmDelivered: 'تم التوصيل',
      delivered: 'تم التوصيل ✔',
      statusLabels: {
        assigned: 'مُسند', accepted: 'تم القبول',
        on_the_way_to_store: 'في الطريق للمتجر', arrived_at_store: 'وصل المتجر',
        picked_up_from_store: 'تم الاستلام من المتجر',
        on_the_way_to_customer: 'في الطريق للزبون', arrived_at_customer: 'وصل الزبون',
        delivered: 'تم التوصيل', cancelled: 'ملغي',
        returned: 'مرتجع', return_initiated: 'إعادة للمتجر',
        returning_to_store: 'عودة للمتجر', returned_at_store: 'تم الإرجاع',
        delivery_failed: 'تعذر التوصيل', not_delivered: 'لم يتم التوصيل', not_received: 'لم يتم الاستلام',
      },
    pickup: 'الاستلام', delivery: 'التوصيل', customer: 'الزبون', phone: 'الهاتف', items: 'المحتويات',
    callCustomer: 'اتصال',
    noOrders: 'لا توجد طلبات', noOrdersSub: 'ستظهر الطلبات الجديدة هنا',
    noActive: 'لا توجد طلبات نشطة', noHistory: 'لا يوجد سجل بعد',
    historyAll: 'الكل', historyEmptyFilter: 'لا توجد طلبات بهذه الحالة',
    completeMore: 'أكمل توصيلات لرؤية سجلك',
    toAccept: 'للقبول', tapForDetails: 'اضغط للتفاصيل',
    collectCash: 'اجمع النقود من الزبون', collectCashSub: 'الدفع عند الاستلام — قبل التسليم',
    alreadyPaid: 'الطلب مدفوع مسبقاً', alreadyPaidSub: 'سلّم وأكّد — لا حاجة لنقود',
    didPickup: 'هل استلمت الطلب؟', didPickupSub: 'يبدو أنك تجاوزت المتجر — اضغط للتأكيد',
    nearCustomer: 'قريب من الزبون!', nearCustomerSub: '150م — تحديث الحالة؟',
    yesUpdate: 'نعم، حدّث',
    store: 'المتجر', iqd: 'د.ع',
    todayEarnings: 'محصل اليوم', weekEarnings: 'محصل الأسبوع',
    myCommission: 'عمولتي', myProfit: 'أرباحك (عمولة)',
    earningsFromOrders: 'من {count} طلب موصّلة',
    avgPerShipment: 'متوسط الربح لكل طلب',
    profitPerShipment: 'ربحك من الطلب',
    ordersDelivered: 'طلبات موصّلة',
    collectedFromCustomers: 'تحصيل من العميل',
    owedToCompany: 'مستحق للشركة', walletBalance: 'المحفظة',
    cashSummary: 'ملخص النقد والتسوية',
    cashHeldPending: 'نقد بانتظار التسليم للشركة',
    cashHeldHint: 'مبالغ COD محصّلة ولم تُسوَّ بعد مع الشركة',
    handedPeriod: 'مُسلَّم للشركة · {period}',
    handedTotal: 'إجمالي المُسلَّم للشركة',
    commissionKept: 'عمولتك المحتفظ بها منها',
    companyHandedOver: 'تم تسليم المستحق للشركة',
    inHand: 'رصيد يدك', totalCollected: 'إجمالي التحصيل', deposited: 'مُسلَّم للشركة',
    awaitingHandover: 'بانتظار التسوية',
    settlementReminder: 'تسوية مطلوبة', settlementReminderBody: '{count} طلب · مستحق للشركة {amount}',
    deliveriesTab: 'التوصيلات', settlementsTab: 'التسويات',
    pendingSettlement: 'بانتظار التسوية', settled: 'تمت التسوية',
    noEarningsYet: 'لا توصيلات في هذه الفترة', noSettlementsYet: 'لا تسويات بعد',
    ordersCount: 'عدد الطلبات', commissionInSettlement: 'عمولة في التسوية',
    paidToCompany: 'دُفع للشركة',
    codHelpTitle: 'كيف تُحسب المبالغ؟',
    codHelpBody: 'عند الدفع عند الاستلام: تحصّل الإجمالي من العميل، عمولتك تبقى لك، والباقي (قيمة المنتج + حصة الشركة) تُسلّمه للشركة عند التسوية.',
    bonusTitle: 'مكافأة الإنجاز!', bonusSub: 'أكملت 5 توصيلات اليوم 🎉',
    withdraw: 'سحب المحصل',
    performance: 'الأداء', acceptance: 'معدل القبول', completion: 'معدل الإنجاز', onTime: 'في الوقت',
    todayOrders: 'طلبات اليوم', noOrdersYet: 'لا توجد طلبات حتى الآن',
    settings: 'الإعدادات', language: 'اللغة',
    alertsSection: 'الإشعارات والتنبيهات', alertsSectionSub: 'داخل التطبيق وعلى الجهاز',
    alertSound: 'صوت التنبيه', alertSoundSub: 'عند وصول طلب أو تحديث',
    vibration: 'الاهتزاز', vibrationSub: 'اهتزاز الجهاز عند الإشعار',
    gpsAutoSection: 'التحديث بالموقع', gpsAutoSectionSub: 'يعتمد على GPS — فعّل تتبع الموقع أعلاه',
    autoPickup: 'تحديث تلقائي عند المتجر', autoPickupSub: 'تحديث الحالة عند الاقتراب من موقع الاستلام',
    autoDeliver: 'تنبيه قرب الزبون', autoDeliverSub: 'إشعار وتحديث الحالة عند الاقتراب من عنوان التسليم',
    pickupRadius: 'مسافة المتجر', deliverRadius: 'مسافة الزبون',
    distanceToStore: 'المسافة للمتجر', distanceToCustomer: 'المسافة للزبون',
    meters: 'م', profileId: 'رقم السائق', rating: 'التقييم', totalDeliveries: 'إجمالي التوصيلات',
    gpsMap: 'الخريطة', gpsSetting: 'تتبع الموقع', gpsSettingSub: 'إرسال موقعك للشركة',
    goOffline: 'الذهاب لغير متصل', goOnline: 'الذهاب لمتصل',
    logout: 'تسجيل خروج',
    callStore: 'اتصال بالمتجر', callCustomer: 'اتصال بالزبون',
    callConfirm: 'تأكيد الاتصال', callConfirmStore: 'هل أنت متأكد من الاتصال بالمتجر؟',
    callConfirmCustomer: 'هل أنت متأكد من الاتصال بالزبون؟',
    yes: 'نعم', no: 'لا', notes: 'ملاحظات',
    retryDelivery: 'إعادة المحاولة', returnToStore: 'إرجاع للمتجر',
    driverNav: ['الشحنات', 'السجل', 'الإعدادات'],
    driverNavShort: ['شحنات', 'سجل', 'إعداد'],
    driverHomeTitle: 'شحنات النقل',
    driverHomeSub: 'الشحنات المسندة إليك بين الفروع',
    driverEmpty: 'لا توجد شحنات في الطريق',
    driverEmptySub: 'ستظهر هنا الشحنات بعد إرسالها من فرع المصدر',
    driverHistoryEmpty: 'لا يوجد سجل شحنات بعد',
    driverHistoryEmptySub: 'تظهر هنا الشحنات التي وصلت فرع الوجهة',
    driverScan: 'مسح تحميل',
    driverScanTitle: 'تأكيد التحميل على الشاحنة',
    driverScanSub: 'امسح باركود الطلب لتأكيد وجوده على الشحنة',
    driverScanConfirm: 'تأكيد',
    driverStops: 'محطات التسليم',
    driverLoaded: 'محمّل',
    driverPendingLoad: 'بانتظار المسح',
    driverBack: 'رجوع',
    driverDest: 'الوجهة',
    driverOrigin: 'المصدر',
    driverOrders: 'طلبات',
    driverSearch: 'بحث برقم الشحنة أو الطلب',
  },
  en: {
    dir: 'ltr', font: "'SF Pro Display',-apple-system,'Segoe UI',sans-serif",
    appName: 'Sari3', greeting0: 'Good Morning', greeting1: 'Good Afternoon', greeting2: 'Good Evening',
    online: 'Online', offline: 'Offline',
    pending: 'Pending', active: 'Active', done: 'Done', earned: 'Collected',
    nav: ['Incoming', 'Active', 'Collected', 'History', 'Settings'],
      incomingTitle: 'Orders awaiting acceptance',
      incomingEmpty: 'No new orders',
      incomingEmptySub: 'Assigned orders will appear here',
      goActiveTab: 'Active orders',
      collectFromCustomer: 'Collect from customer',
      viewOrder: 'View order',
      cod: 'Cash on Delivery', paid: 'Pre-Paid',
      accept: 'Accept Order', reject: 'Reject',
      headToStore: 'Head to Store', arrivedStore: 'Arrived at Store',
      confirmPickup: 'Picked Up from Store',
      headToCustomer: 'Head to Customer', arrivedCustomer: 'Arrived at Customer',
      confirmDelivered: 'Delivered',
      delivered: 'Delivered ✔',
      statusLabels: {
        assigned: 'Assigned', accepted: 'Accepted',
        on_the_way_to_store: 'Heading to Store', arrived_at_store: 'Arrived at Store',
        picked_up_from_store: 'Picked Up',
        on_the_way_to_customer: 'Heading to Customer', arrived_at_customer: 'Arrived at Customer',
        delivered: 'Delivered', cancelled: 'Cancelled',
        returned: 'Returned', return_initiated: 'Returning to Store',
        returning_to_store: 'Returning to Store', returned_at_store: 'Returned to Store',
        delivery_failed: 'Failed', not_delivered: 'Not Delivered', not_received: 'Not Received',
      },
    pickup: 'Pickup', delivery: 'Delivery', customer: 'Customer', phone: 'Phone', items: 'Items',
    callCustomer: 'Call',
    noOrders: 'No Orders', noOrdersSub: 'New orders will appear here',
    noActive: 'No Active Orders', noHistory: 'No history yet',
    historyAll: 'All', historyEmptyFilter: 'No orders in this category',
    completeMore: 'Complete deliveries to see your history',
    toAccept: 'to accept', tapForDetails: 'Tap for details',
    collectCash: 'Collect Cash from Customer', collectCashSub: 'COD — collect before handing over',
    alreadyPaid: 'Order Already Paid Online', alreadyPaidSub: 'Just deliver and confirm — no cash needed',
    didPickup: 'Did you pick up the order?', didPickupSub: 'You passed the store — tap to confirm',
    nearCustomer: 'Getting close to customer!', nearCustomerSub: '150m away — update status?',
    yesUpdate: 'Yes, Update',
    store: 'Store', iqd: 'IQD',
    todayEarnings: "Today's Collection", weekEarnings: 'This Week',
    myCommission: 'My Commission', myProfit: 'Your Profit (Commission)',
    earningsFromOrders: 'from {count} delivered orders',
    avgPerShipment: 'Avg profit per order',
    profitPerShipment: 'Your profit',
    ordersDelivered: 'Delivered',
    collectedFromCustomers: 'Collected from Customer',
    owedToCompany: 'Owed to Company', walletBalance: 'Wallet',
    cashSummary: 'Cash & Settlement',
    cashHeldPending: 'Cash awaiting handover',
    cashHeldHint: 'COD collected, not yet settled with company',
    handedPeriod: 'Handed to company · {period}',
    handedTotal: 'Total handed to company',
    commissionKept: 'Your commission kept',
    companyHandedOver: 'Company share handed over',
    inHand: 'Cash in Hand', totalCollected: 'Total Collected', deposited: 'Deposited',
    awaitingHandover: 'Awaiting settlement',
    settlementReminder: 'Settlement Due', settlementReminderBody: '{count} orders · owe company {amount}',
    deliveriesTab: 'Deliveries', settlementsTab: 'Settlements',
    pendingSettlement: 'Pending', settled: 'Settled',
    noEarningsYet: 'No deliveries in this period', noSettlementsYet: 'No settlements yet',
    ordersCount: 'Orders', commissionInSettlement: 'Commission',
    paidToCompany: 'Paid to Company',
    codHelpTitle: 'How amounts work',
    codHelpBody: 'For COD: collect the total from the customer, keep your commission, and hand over the rest (product value + company share) at settlement.',
    bonusTitle: 'Achievement Bonus!', bonusSub: 'You completed 5 deliveries today 🎉',
    withdraw: 'Withdraw Collection',
    performance: 'Performance', acceptance: 'Acceptance Rate', completion: 'Completion Rate', onTime: 'On Time',
    todayOrders: "Today's Orders", noOrdersYet: 'No orders yet',
    settings: 'Settings', language: 'Language',
    alertsSection: 'Alerts & notifications', alertsSectionSub: 'In-app and on your device',
    alertSound: 'Alert sound', alertSoundSub: 'When a new order or update arrives',
    vibration: 'Vibration', vibrationSub: 'Vibrate on notifications',
    gpsAutoSection: 'Location-based updates', gpsAutoSectionSub: 'Requires GPS tracking enabled above',
    autoPickup: 'Auto-update at store', autoPickupSub: 'Update status when near pickup location',
    autoDeliver: 'Alert near customer', autoDeliverSub: 'Notify and update when close to delivery address',
    pickupRadius: 'Store distance', deliverRadius: 'Customer distance',
    distanceToStore: 'Distance to store', distanceToCustomer: 'Distance to customer',
    appSection: 'App',
    meters: 'm', profileId: 'Rider ID', rating: 'Rating', totalDeliveries: 'Total Deliveries',
    gpsMap: 'Map', gpsSetting: 'GPS Tracking', gpsSettingSub: 'Send your location to the company',
    goOffline: 'Go Offline', goOnline: 'Go Online',
    logout: 'Logout',
    callStore: 'Call Store', callCustomer: 'Call Customer',
    callConfirm: 'Confirm Call', callConfirmStore: 'Are you sure you want to call the store?',
    callConfirmCustomer: 'Are you sure you want to call the customer?',
    yes: 'Yes', no: 'No', notes: 'Notes',
    retryDelivery: 'Retry Delivery', returnToStore: 'Return to Store',
    driverNav: ['Shipments', 'History', 'Settings'],
    driverNavShort: ['Runs', 'Log', 'Set'],
    driverHomeTitle: 'Transfer shipments',
    driverHomeSub: 'Inter-branch shipments assigned to you',
    driverEmpty: 'No shipments on the road',
    driverEmptySub: 'Assigned truck runs appear here after dispatch',
    driverHistoryEmpty: 'No shipment history yet',
    driverHistoryEmptySub: 'Completed transfers to the destination branch appear here',
    driverScan: 'Scan load',
    driverScanTitle: 'Confirm load on truck',
    driverScanSub: 'Scan the order barcode to confirm it is on this shipment',
    driverScanConfirm: 'Confirm',
    driverStops: 'Stops',
    driverLoaded: 'Loaded',
    driverPendingLoad: 'Awaiting scan',
    driverBack: 'Back',
    driverDest: 'Destination',
    driverOrigin: 'Origin',
    driverOrders: 'orders',
    driverSearch: 'Search by TRF or order number',
  },
};

export const STATUS_FLOW_MAP = {
  assigned: ['accepted', 'cancelled'],
  accepted: ['on_the_way_to_store', 'cancelled', 'delivery_failed'],
  on_the_way_to_store: ['arrived_at_store', 'delivery_failed', 'cancelled'],
  arrived_at_store: ['picked_up_from_store', 'delivery_failed', 'cancelled'],
  picked_up_from_store: ['on_the_way_to_customer', 'return_initiated', 'delivery_failed'],
  on_the_way_to_customer: ['arrived_at_customer', 'return_initiated', 'delivery_failed'],
  arrived_at_customer: ['delivered', 'delivery_failed', 'not_received', 'return_initiated'],
  delivered: [],
  cancelled: [],
  returned: [],
  return_initiated: ['returned', 'delivery_failed'],
  delivery_failed: [],
  not_received: ['return_initiated', 'delivery_failed'],
};

export const STATUS_META = {
  assigned:              { colorKey: 'purple', icon: '📋' },
  accepted:              { colorKey: 'blue',   icon: '👍' },
  on_the_way_to_store:   { colorKey: 'blue',   icon: '🛵' },
  arrived_at_store:      { colorKey: 'orange', icon: '🏪' },
  picked_up_from_store:  { colorKey: 'orange', icon: '📦' },
  on_the_way_to_customer:{ colorKey: 'blue',   icon: '🚀' },
  arrived_at_customer:   { colorKey: 'green',  icon: '📍' },
  delivered:             { colorKey: 'green',  icon: '✔️' },
  not_delivered:         { colorKey: 'orange', icon: '⚠️' },
  cancelled:             { colorKey: 'red',    icon: '✖' },
  returned_at_store:     { colorKey: 'red',    icon: '↩️' },
  returning_to_store:    { colorKey: 'red',    icon: '↩️' },
  returned:              { colorKey: 'red',    icon: '↩️' },
  return_initiated:      { colorKey: 'red',    icon: '↩️' },
  delivery_failed:       { colorKey: 'red',    icon: '⚠️' },
  not_received:          { colorKey: 'red',    icon: '⚠️' },
};

export const NEXT_STATUS = {
  assigned: 'accepted',
  accepted: 'on_the_way_to_store',
  on_the_way_to_store: 'arrived_at_store',
  arrived_at_store: 'picked_up_from_store',
  picked_up_from_store: 'on_the_way_to_customer',
  on_the_way_to_customer: 'arrived_at_customer',
  arrived_at_customer: 'delivered',
};

export function fmtCurrency(n, symbol) {
  if (n == null || isNaN(n)) return '0';
  const num = Number(n);
  const formatted = num % 1 === 0 ? num.toLocaleString() : num.toFixed(2);
  return formatted + ' ' + (symbol || 'د.ع');
}
